export const cacheKey = "/app_settings/territories_data" as const;
